<template>
  <a-modal :title="modal.title" v-model="modal.visible" @ok="handleOk" @cancel="handleCancel" :width="700">
    <div>
      <div class="queryView flex justify-between mb-5">
        <a-form layout="inline" :form="modal.form" :colon="false" class="form">
          <a-form-item label="产品名称">
            <a-input v-decorator="['productName']" placeholder="请输入产品名称"></a-input>
          </a-form-item>
        </a-form>
        <div>
          <a-button class="mr-3" type="default" @click="resetAndQuery">重置搜索</a-button>
          <a-button class="" type="primary" @click="doQuery(1)">立即搜索</a-button>
        </div>
      </div>
      <a-table
        class="origin-style ant-info-table"
        :rowKey="(record, index)=>{return index}"
        :columns="tableColumns"
        :dataSource="dataSource"
        :rowSelection="getRowSelection()"
        size="middle"
      ></a-table>
    </div>
  </a-modal>
</template>

<script>
import { toolMixin } from '@/utils/mixin'
export default {
  mixins: [toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '10%',
        align: 'center',
        customRender: (text, row, index) => {
          return <div>{index + 1}</div>
        },
      },
      {
        title: '产品名称',
        width: '40%',
        align: 'center',
        dataIndex: 'productName',
      },
      {
        title: '领区',
        width: '16%',
        align: 'center',
        dataIndex: 'area',
      },
      {
        title: '供应商',
        width: '20%',
        align: 'center',
        dataIndex: 'supplierCompanyName',
      },
    ]
    return {
      // 添加送签产品modal
      modal: {
        visible: false,
        form: this.$form.createForm(this),
        title: '',
        data: {},
      },
      tableColumns: tableColumns,
      dataSource: [],
      rowKey: 'productId',
      selectedRowKeys: [],
      selectedRows: [],
    }
  },
  methods: {
    getRowSelection(type = 'checkbox') {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        columnTitle: '选择',
        columnWidth: 80,
        type: type,
      }
    },
    start() {
      this.reset$t()
      this.doQuery()
      this.modal.title = `选择公证产品`
      this.modal.visible = true
      return new Promise((resolve, reject) => {
        this.$once('end', function(state, result) {
          if (state === 'ok') {
            resolve(result)
          }
          if (state === 'cancel') {
            reject(new Error('E_CANCEL'))
          }
          this.modal.visible = false
        })
      })
    },
    async handleOk() {
      if (!this.selectedRows.length) {
        return this.$message.error('请选择')
      }
      this.$emit('end', 'ok', this.selectedRows)
    },
    handleCancel() {
      this.$emit('end', 'cancel')
    },
    async doQuery() {
      const params = this.modal.form.getFieldsValue()
      const res = await this.$axios.post('/product-web-api/admin/notarization/pageList', {
        data: {
          ...params,
        },
        pageSize: 9999,
        pageNum: 1,
      })
      this.dataSource = res.data.content
    },
    resetAndQuery() {
      this.modal.form.resetFields()
      this.doQuery()
    },
  },
}
</script>

<style></style>
